<template>
  <v-menu
    offset-y
    origin="right top"
    left
    transition="slide-y-transition"
    nudge-top="-10"
    :nudge-width="200"
    :max-width="350"
    v-model="menu"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <ui-button
        icon="icon-user"
        shadow
        icon-size="26"
        v-on="on"
        data-cy="usermenu-btn"
      ></ui-button>
    </template>
    <div>
      <div class="email-container">
        <span class="fs-14 fw-bold">{{ email }}</span>
      </div>
      <v-list class="dropdown-list">
        <v-list-item @click="$router.push({ name: 'user-settings' })">
          <v-icon size="20" color="orange" class="mr-2">
            icon-sliders
          </v-icon>
          <span>{{ $t("message.common.userAccount") }}</span>
        </v-list-item>
        <v-list-item class="ml-1" @click="logoutUser" data-cy="logout-btn">
          <span class="zmdi" :class="logout.icon"></span>
          <span>{{ $t(logout.title) }}</span>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>
<script>
export default {
  data() {
    return {
      email: this.$store.state.auth.user.email,
      menu: false,
      logout: {
        id: 4,
        title: "message.common.logOut",
        icon: "zmdi-power mr-3 error--text"
      }
    };
  },
  methods: {
    logoutUser() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>

<style lang="scss" scoped>
.email-container {
  background-color: $primary;
  border-color: $primary;
  padding: $spacing * 2 $spacing * 2.5;
  color: $light-3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
